import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

export const EngravingLogoWrapper = styled(Box)<{
  $height?: number;
  $width?: number;
}>`
  flex-shrink: 0;
  &&&& {
    svg {
      margin: 0;
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  ${({ $height, $width, theme }) => css`
    width: ${$width ? $width : 102}px;
    height: ${$height ? $height : 102}px;
    ${theme.media.md.up} {
      width: ${$width ? $width : 108}px;
      height: ${$height ? $height : 108}px;
    }
  `}
`;
